import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Client wrapper around `PageHeader` so the `/approvals` RSC can render
 * i18n labels without lifting itself into a client component.
 */
export function ApprovalsPageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("approvals.title")}
      subtitle={t("approvals.subtitle")}
    />
  );
}
